import React from "react";
import {
	Box,
	TextField,
	FormControl,
	InputAdornment,
	InputLabel,
	Input,
	IconButton,
	Button,
	Typography,
	Select,
	MenuItem,
	FormHelperText,
	Alert,
	Tabs,
	Tab
} from "@mui/material";
import {
	AccountCircleOutlined,
	Visibility,
	VisibilityOff,
	LockOutlined,
	Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set, range } from "lodash";
import { Grid } from "../../components/table";
import { CONFIG } from "../../../config";
import axios from "axios";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import moment from "moment";
import { getFormState } from "../../../helpers/form";
import dayjs from "dayjs";

import IosShareIcon from "@mui/icons-material/IosShare";
import PropTypes from 'prop-types';
const durationPulgin = require('dayjs/plugin/duration')
dayjs.extend(durationPulgin)


const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

function CustomTabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 1 }}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

CustomTabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}


const getTotalWeekOfCurrentMonth = () => {
	return Math.ceil(dayjs().daysInMonth() / 7)
}

const getWeekOfMonth = () => {
	return dayjs.duration().weeks();
}

export const MasterData = (props) => {
	const [value, setValue] = React.useState(0);

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<Box sx={{ width: '100%' }}>
			<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
				<Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
					<Tab label="ACTIVE" {...a11yProps(0)} />
					<Tab label="CLOSED" {...a11yProps(1)} />
					{/* <Tab label="BAD DATA" {...a11yProps(2)} />
					<Tab label="INBOUND DATA" {...a11yProps(3)} /> */}
				</Tabs>
			</Box>
			<CustomTabPanel value={value} index={0}  >
				<List heading={''} sx={{fontSize: '.1em'}}type={'active'} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}  >
				<List heading={''} type={'archive'} />
			</CustomTabPanel>
			{/* <CustomTabPanel value={value} index={2}  >
				<List heading={'Bad Data List'} type={'bad'} />
			</CustomTabPanel>
			<CustomTabPanel value={value} index={3}  >
				<List heading={'Inbound List'} type={'inbound'} />
			</CustomTabPanel> */}
		</Box>
	)
}

export const List = ({ heading, type }) => {
	const {
		roles,
		user,
		users,
		Designations,
		Departments,
		Languages,
		Districts,
	} = useSelector((state) => state.user || {});
	const userStore = useSelector((state) => state.user || {});
	console.log('length', dayjs.duration().asWeeks())

	const [active, setActive] = useState("Employees");
	const [data, setData] = useState([]);
	const [open, setOpen] = useState(false);
	const [action, setAction] = useState("new");
	const [saved, setSaved] = useState(null);
	const [index, setIndex] = useState(null);
	const [openConfirm, setOpenConfirm] = useState(false);
	const [assigning, setAssigning] = useState(false);
	const [assignCompleted, setAssignCompleted] = useState(false)

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [count, setCount] = useState(0);
	const [selectedSankalpData, setSelectedSankalpData] = useState(null);
	const [filter, setFilter] = useState({
		from: null,// dayjs("01-01-2023"),
		to: null,//dayjs(),
		cfrom: null,
		cto: null,
		status: 'Any',
		motherStatus: 'Any',
		telecaller: 'Any',
		district: 'Any',
		week: getWeekOfMonth()
	});

	useEffect(() => {
		console.log(filter)
	}, [filter])





	const getList = () => {
		setData([]);
		axios
			.get(
				API_HOST_CRM +
				`/cases?limit=${rowsPerPage}` +
				`&page=${page}&type=${type}` +
				`${filter.from ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}` : ""}` +
				`${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}` +
				`${filter.status ? `&status=${filter.status}` : ""}` +
				`${filter.district ? `&district=${filter.district}` : ''}` +
				`${filter.motherId ? `&motherId=${filter.motherId}` : ''}` +
				`${filter.motherName ? `&motherName=${filter.motherName}` : ''}` +
				`${filter.contact ? `&contact=${filter.contact}` : ''}` +
				`${filter.motherStatus ? `&motherStatus=${filter.motherStatus}` : ''}` +
				`${filter.telecaller ? `&telecaller=${filter.telecaller}` : ''}` +
				`${filter.firstReceived ? `&firstReceived=${filter.firstReceived}` : ''}` +
				`${filter.cfrom ? `&cfrom=${dayjs(filter.cfrom).format("YYYY-MM-DD")}` : ""}` +
				`${filter.cto ? `&cto=${dayjs(filter.cto).format("YYYY-MM-DD")}` : ""}` +
				`${filter.week ? `&week=${filter.week}` : ""}`)
			.then((resp) => {
				if (resp.data && resp.data.success) {
					setData(resp.data.cases);
					setCount(resp.data.count);
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		getList();
	}, [page, rowsPerPage, filter]);

	useEffect(() => {
		getList();
	}, []);

	const exportMotherReport = (data) => {
		axios
			.get(
				API_HOST_CRM +
				`/export-motherData?id=${data.motherID}&from=${encodeURIComponent(
					dayjs(filter.from).format("YYYY-MM-DD")
				)}&to=${encodeURIComponent(dayjs(filter.to).format("YYYY-MM-DD"))}
				
				`,
				{
					responseType: "arraybuffer",
				}
			)
			.then((resp) => {
				if (resp) {
					const url = window.URL.createObjectURL(new Blob([resp.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						`Mother_Report_${data.motherID}+${data.name}.xlsx`
					);
					document.body.appendChild(link);
					link.click();
					console.log(resp);
					link.remove();
				}
			})
			.catch((e) => {
				console.log(e);
			});
	};

	return (
		<>

			<ToolBar
				name={heading}
				height={'10em'}
				buttons={
					[
						{
							name: assignCompleted ? 'Assign Completed' : assigning ? 'Assigning.....' : 'Assign',
							// type: 'chip',
							icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
							onClick: () => {
								if (!assigning && !assignCompleted) {
									setAssigning(true)
									axios
										.get(
											API_HOST_CRM + '/allocate-auto'
										)
										.then((resp) => {
											if (resp.data && resp.data.success) {
												setAssigning(false)
												setAssignCompleted(true)
												setTimeout(() => {
													setAssignCompleted(false)
												}, 2000)

											}
											setAssigning(false)
										})
										.catch((e) => {
											console.log(e);
											setAssigning(false)
										});
								}

							}
						}
					]
				}
				onClearFilter={() => {
					setFilter({
						from: null,
						to: null,
						cfrom: null,
						cto: null,
						firstReceived: null,
						motherName: '',
						motherId: '',
						contact: '',
						status: null,
						motherStatus: null,
						telecaller: null,
						district: null,
					})
				}}
				filters={[

					// {
					// 	field: {
					// 		name: "motherId",
					// 		type: "text",
					// 		label: "Mother ID",

					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					// {
					// 	field: {
					// 		name: "motherName",
					// 		type: "text",
					// 		label: "Name",
					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					// {
					// 	field: {
					// 		name: "contact",
					// 		type: "text",
					// 		label: "Contact",
					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					{
						field: {
							name: "status",
							type: "select",
							label: "Status",
							option: { key: "Status", value: "_id", label: "name" },
							noMb: true
						},
						data: {
							Status: [
								"Any",
								"Queue",
								"Pending",
								"Active",
								"No answer",
								"Call done",
								"Busy",
								"No network",
								"Invalid",
								"Incoming not available",
								"Not in the portal",
								"Miscarriage",
								"Call Incomplete",
								"Deceased Child",
								"Switched off",
								"Wrong number",
								"Declined",
								"Out of service",
								"Language Barrier",
								"Deceased Mother",
								"Deceased (Mother and Child)",
								"Duplicate Mother Id",
							].map((d) => ({ _id: d, name: d })),
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					// {
					// 	field: {
					// 		name: "motherStatus",
					// 		type: "select",
					// 		label: "Mother Status",
					// 		option: { key: "MotherStatus", value: "_id", label: "name" },
					// 		noMb: true
					// 	},
					// 	data: {
					// 		MotherStatus: [
					// 			"Any",
					// 			"Currently Expecting",
					// 			"Delivered"
					// 		].map((d) => ({ _id: d, name: d })),
					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					// {
					// 	field: {
					// 		name: "district",
					// 		type: "select",
					// 		label: "District",
					// 		option: { key: "Districts", value: "_id", label: "name" },
					// 		noMb: true
					// 	},
					// 	data: {
					// 		Districts: [
					// 			{
					// 				_id: 'Any',
					// 				name: 'Any'
					// 			},
					// 			...(Districts || [])
					// 		]
					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					{
						field: {
							name: "telecaller",
							type: "select",
							label: "Telecaller",
							option: { key: "Telecallers", value: "_id", label: "name" },
						},
						data: {
							Telecallers: [
								{
									_id: 'Any',
									name: 'Any'
								},
								...((users || []).filter(u => {
									return u.roles.includes(process.env.REACT_APP_TELECALLER)
								}))
							]
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "week",
							type: "select",
							label: "Week",
							option: { key: "Weeks", value: "_id", label: "name" },
						},
						data: {
							Weeks: [
								{
									_id: 'Any',
									name: 'Any'
								},
								...(range(0, getTotalWeekOfCurrentMonth()).map((w) => {
									return {
										_id: `${w}`,
										name: `Week ${w + 1}`
									}
								}))
							]
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					// {
					// 	field: {
					// 		name: "firstReceived",
					// 		type: "date",
					// 		label: "First Received",
					// 	},
					// 	onChange: (name, value) => {
					// 		filter[name] = value;
					// 		setFilter({ ...filter });
					// 	},
					// 	state: filter,
					// },
					{
						field: {
							name: "from",
							type: "date",
							label: "Assign From",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "to",
							type: "date",
							label: "Assign To",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},

					{
						field: {
							name: "cfrom",
							type: "date",
							label: "Call From",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
					{
						field: {
							name: "cto",
							type: "date",
							label: "Call To",
						},
						onChange: (name, value) => {
							filter[name] = value;
							setFilter({ ...filter });
						},
						state: filter,
					},
				]}
			/>
			<Box sx={{ mt: 2 }}>
				<Grid
					data={data}
					// filter={filter}
					columns={[
						{
							id: "motherID",
							// label: "Mother ID",
							minWidth: 70,
							editable: true,
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							field: {
								name: "motherId",
								type: "text",
								label: "Mother ID",

							},
							state: filter,
						},
						{
							id: "name",
							// label: "Name",
							minWidth: 70, editable: true,
							field: {
								name: "motherName",
								type: "text",
								label: "Name",
							},
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							state: filter,
						},

						{
							id: 'contact',
							// label: 'Contact',
							minWidth: 40,
							format: (data, row) => {
								if (row) {
									if (row.contactNumbers && row.contactNumbers.length > 0) {
										return row.contactNumbers.join(",")
									} else {
										return data || ''
									}
								} else {
									return ''
								}
							},
							editable: true,
							field: {
								name: "contact",
								type: "text",
								label: "Contact",
							},
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							state: filter,
						},
						{
							id: "districtName",
							// label: "District",
							minWidth: 50,
							isSelect: true,
							field: {
								name: "district",
								type: "select",
								label: "District",
								option: { key: "Districts", value: "_id", label: "name" },
								noMb: true
							},
							data: {
								Districts: [
									{
										_id: 'Any',
										name: 'Any'
									},
									...(Districts || [])
								]
							},
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							state: filter,
						},
						{
							id: "dateReceived",
							// label: "First Received",
							minWidth: 50,
							editable: true,
							format: (data, row) => {
								return data ? dayjs(data).format('DD-MM-YYYY') : ''
							},
							field: {
								name: "firstReceived",
								type: "date",
								label: "Upload Date",
							},
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							state: filter,
						},

						{
							id: 'lastCallDate', label: 'Last Call', minWidth: 50, format: (data, row) => {

								if (data) {
									return `${dayjs(data).format('DD-MM-YYYY')} | ${row.status}`
								}
								return 'NA'
							}
						},
						{ id: "allocatedTo", label: "AllocatedTo", minWidth: 70 },
						{
							id: "callDate",
							label: "Assigned on",
							minWidth: 70,
							format: (data, row) => {
								return data ? dayjs(data).format("DD-MM-YYYY") : "";
							},
						},
						// { id: "status", label: "Status", minWidth: 50 },

						...(type == 'active' ? [{
							id: 'motherStatus',
							//  label: 'Mother Status',
							  minWidth: 150, format: (data, row) => {
								return `${data || ''}  ${row.childStatus ? '| 	' + row.childStatus : ''}`
							},
							isSelect : true,
							field: {
								name: "motherStatus",
								type: "select",
								label: "Mother Status",
								option: { key: "MotherStatus", value: "_id", label: "name" },
								noMb: true
							},
							data: {
								MotherStatus: [
									"Any",
									"Currently Expecting",
									"Delivered"
								].map((d) => ({ _id: d, name: d })),
							},
							onChange: (name, value) => {
								filter[name] = value;
								setFilter({ ...filter });
							},
							state: filter,
							
						},
						{
							id: 'nextCallDue', label: 'Next Call Due', minWidth: 50, format: (data, row) => {
								return data ? dayjs(data).format('DD-MM-YYYY') : 'NA'
							}
						}] : [])


						// {
						// 	id: "sankalpId",
						// 	label: "Sankalp Data",
						// 	minWidth: 50,
						// 	format: (data, row) => {
						// 		if (data) {
						// 			return (
						// 				<Button
						// 					onClick={() => {
						// 						setOpen(true);
						// 						setSelectedSankalpData(data);
						// 					}}
						// 				>
						// 					View
						// 				</Button>
						// 			);
						// 		} else {
						// 			return "";
						// 		}
						// 	},
						// },
						// {
						// 	id: "_id",
						// 	label: "Action",
						// 	minWidth: 70,
						// 	format: (data, row) => {
						// 		return (
						// 			<Button
						// 				onClick={(e) => {
						// 					exportMotherReport(row);
						// 				}}
						// 			>
						// 				Report
						// 			</Button>
						// 		);
						// 	},
						// },
					]}
					pagination={{
						rowsPerPageOptions: [10, 25, 50],
						page,
						rowsPerPage,
						onPageChange: (event, newPage) => {
							setPage(newPage);
						},
						onRowsPerPageChange: (event) => {
							setRowsPerPage(+event.target.value);
							setPage(0);
						},
						count,
					}}
				></Grid>
			</Box>

			<Modal
				open={open}
				handleClose={() => {
					setOpen(false);
				}}
				head={`Sankalp Data`}
				buttons={[
					{
						name: "Cancel",
						onClick: () => {
							setOpen(false);
						},
					},
				]}
			>
				{selectedSankalpData &&
					selectedSankalpData.sankalpData &&
					Object.keys(selectedSankalpData.sankalpData).map((s, i) => {
						const map = {
							'pregStatus': 'Pregnancy Status',
							'advice': 'Advice',
							'pregnancyNumber': 'Pregnancy Number',
							'pretermDelivery': 'Pre-term Delivery',
							'nearResidance': 'Near By Residence',
							'trimester': 'Trimester'
						}
						return (
							<Box key={i} sx={{ display: 'flex', mt: 1 }}>
								<Typography variant='p'>{(map[s] || s)}: </Typography>&nbsp;
								<Typography variant='p' sx={{ color: 'grey', fontSize: '.9em' }}>{selectedSankalpData.sankalpData[s]}</Typography>
							</Box>
						)
					})
				}
			</Modal>
		</>
	);
};
